import IdentificationError from './IdentificationError';
class InvalidInvestorId extends IdentificationError {
    constructor(options) {
        super('Investor id is invalid', options);
    }
}
export default InvalidInvestorId;
